/**
 *  @class
 *  @function SlideShow
 */
if (!customElements.get('slide-show')) {
  class SlideShow extends HTMLElement {
    constructor() {
      super();
      const slideshow = this;
      let
        parent_section = slideshow.closest('.shopify-section'),
        dots = slideshow.dataset.dots === 'true',
        slideshow_slides = Array.from(slideshow.querySelectorAll('.carousel__slide')),
        autoplay = slideshow.dataset.autoplay == 'false' ? false : parseInt(slideshow.dataset.autoplay, 10),
        align = slideshow.dataset.align == 'center' ? 'center' : 'left',
        fade = slideshow.dataset.fade == 'true' ? true : false,
        pageDots = slideshow.dataset.dots == 'true' ? true : false,
        prev_button = slideshow.querySelector('.flickity-prev'),
        next_button = slideshow.querySelector('.flickity-next'),
        header = document.querySelector('theme-header'),
        custom_dots = slideshow.querySelector('.flickity-custom-dots'),
        custom_navigation = slideshow.querySelector('.flickity-custom-navigation'),
        autoplay_progress = slideshow.querySelector('.slideshow--autoplay-progress'),
        progress_bar = slideshow.parentNode.querySelector('.flickity-progress--bar'),
        animations = [],
        rightToLeft = document.dir === 'rtl',
        cell_align = (align == 'left' && rightToLeft ? 'right' : 'left'),
        animations_enabled = document.body.classList.contains('animations-true') && typeof gsap !== 'undefined',
        selectedIndex = 0,
        args = {
          wrapAround: true,
          cellAlign: cell_align,
          pageDots: pageDots,
          contain: true,
          fade: fade,
          autoPlay: autoplay,
          rightToLeft: rightToLeft,
          prevNextButtons: false,
          cellSelector: '.carousel__slide',
          on: {}
        };
      this.paused = false;
      if (custom_dots) {
        args.pageDots = false;
      }
      if (slideshow.classList.contains('image-with-text-slideshow--content')) {
        let main_slideshow = slideshow.parentNode.querySelector('.image-with-text-slideshow--image');
        args.draggable = false;
        args.asNavFor = main_slideshow;
      }
      if (slideshow.classList.contains('image-with-text-slideshow--image')) {
        let image_slideshow_slides = slideshow.querySelectorAll('.image-with-text-slideshow--image-media');

        if (image_slideshow_slides.length) {
          if (image_slideshow_slides[0].classList.contains('desktop-height-auto')) {
            args.adaptiveHeight = true;
          }
        }
      }
      if (slideshow.classList.contains('image-with-text-slideshow--content') ||
        slideshow.classList.contains('customer-reviews--content') ||
        slideshow.classList.contains('customer-reviews--image')) {
        args.adaptiveHeight = true;
      }
      if (slideshow.classList.contains('customer-reviews--carousel')) {
        args.wrapAround = false;
        args.adaptiveHeight = false;
        args.resize = true;
        args.on.ready = function () {
          let flkty = this;
          flkty.resize();
          document.fonts.ready.then(function () {
            flkty.resize();
          });
        };
      }
      if (slideshow.classList.contains('collection-grid__carousel')) {
        args.wrapAround = false;
      }
      // Main Slideshow
      if (slideshow.classList.contains('main-slideshow')) {

        if (animations_enabled) {
          slideshow.prepareAnimations(slideshow, animations);
        }

        args.on = {
          staticClick: function () {
            this.unpausePlayer();
          },
          ready: function () {
            let flkty = this;

            // Transparent Header padding.
            if (header) {
              if (header.classList.contains('transparent--true')) {
                let sections = Array.from(document.querySelector('#main-content').querySelectorAll(':scope > .shopify-section')),
                  i = sections.indexOf(parent_section);

                if (i == 0 && slideshow.classList.contains('section-spacing--disable-top')) {
                  slideshow.classList.add('slideshow--top');
                }
              }
            }
            // Animations.
            if (animations_enabled) {
              slideshow.animateSlides(0, slideshow, animations);
            }

            // AutoPlay Progress
            if (autoplay && autoplay_progress && animations_enabled) {
              slideshow.setupAutoplayProgress(slideshow);
            }

            // Höhen-Gleichheit auf Mobile - SOFORT nach Ready
            if (window.innerWidth <= 767) {
              setTimeout(() => {
                slideshow.equalizeSlideHeights(slideshow);
              }, 300);
            }

            // Fonts resize
            document.fonts.ready.then(function () {
              flkty.resize();
              // Slide-Höhen nach Font-Load angleichen
              if (window.innerWidth <= 767) {
                setTimeout(() => {
                  try {
                    slideshow.equalizeSlideHeights(slideshow);
                  } catch (error) {
                    console.error('Error in font-load height equalization:', error);
                  }
                }, 200);
              }
            });

            // Video Support.
            let video_container = flkty.cells[0].element.querySelector('.slideshow__slide-video-bg');
            if (video_container) {

              if (video_container.querySelector('iframe')) {
                video_container.querySelector('iframe').onload = function () {
                  slideshow.videoPlay(video_container);
                };
              } else if (video_container.querySelector('video')) {
                video_container.querySelector('video').onloadstart = function () {
                  slideshow.videoPlay(video_container);
                };
              }
            }
          },
          change: function (index) {
            let flkty = this,
              previousIndex = fizzyUIUtils.modulo(flkty.selectedIndex - 1, flkty.slides.length);

            // Animations.
            if (animations_enabled) {
              slideshow.animateReverse(previousIndex, slideshow, animations);
              slideshow.animateSlides(index, slideshow, animations);
            }

            // Color changes.
            let color_text = getComputedStyle(this.selectedElement).getPropertyValue('--color-text');
            if (autoplay_progress && animations_enabled) {
              autoplay_progress.style.setProperty('--color-body', color_text);
            }
            let dots = slideshow.querySelector('.flickity-page-dots');
            if (dots) {
              dots.style.setProperty('--color-body', color_text);
            }

            // Custom Dots.
            if (custom_navigation) {
              custom_navigation.querySelector('.flickity-custom-navigation--current').innerHTML = this.selectedIndex + 1;
            }

            // Höhen-Gleichheit nach Slide-Wechsel
            if (window.innerWidth <= 767) {
              setTimeout(() => {
                slideshow.equalizeSlideHeights(slideshow);
              }, 100);
            }

            // AutoPlay Progress
            if (autoplay) {

              if (flkty.player.state !== 'paused') {
                flkty.stopPlayer();
                flkty.playPlayer();
              }
            }
            if (autoplay && autoplay_progress && animations_enabled) {
              slideshow.autoPlayProgressTL.progress(0);

              if (flkty.player.state !== 'paused') {
                slideshow.autoPlayProgressTL.play();
              }
            }

            // Video Support.
            // previous slide
            let video_container_prev = flkty.cells[previousIndex].element.querySelector('.slideshow__slide-video-bg');
            if (video_container_prev) {
              slideshow.videoPause(video_container_prev);
            }
            // current slide
            let video_container = flkty.cells[index].element.querySelector('.slideshow__slide-video-bg');
            if (video_container) {
              if (video_container.querySelector('iframe')) {
                if (video_container.querySelector('iframe').classList.contains('lazyload')) {
                  video_container.querySelector('iframe').addEventListener('lazybeforeunveil', slideshow.videoPlay(video_container));
                  lazySizes.loader.checkElems();
                } else {
                  slideshow.videoPlay(video_container);
                }
              } else if (video_container.querySelector('video')) {
                slideshow.videoPlay(video_container);
              }
            }

          }
        };
        if (slideshow.classList.contains('desktop-height-image') || slideshow.classList.contains('mobile-height-image')) {
          args.adaptiveHeight = true;
        }
      }

      // Media with tabs
      if (slideshow.classList.contains('media-with-tabs--media')) {
        args.draggable = false;
        args.on = {
          staticClick: function () {
            this.unpausePlayer();
          },
          ready: function () {
            let flkty = this;

            // Video Support.
            let video_container = flkty.cells[0].element.querySelector('.media-with-tabs--media--video');
            if (video_container) {
              video_container.querySelector('video').onloadstart = function () {
                slideshow.videoPlay(video_container);
              };
            }
          },
          change: function (index) {
            let flkty = this,
              previousIndex = fizzyUIUtils.modulo(flkty.selectedIndex - 1, flkty.slides.length);

            // Video Support.
            // previous slide
            let video_container_prev = flkty.cells[previousIndex].element.querySelector('.media-with-tabs--media--video');
            if (video_container_prev) {
              slideshow.videoPause(video_container_prev);
            }
            // current slide
            let video_container = flkty.cells[index].element.querySelector('.media-with-tabs--media--video');
            if (video_container) {
              slideshow.videoPlay(video_container);
            }
          }
        };
      }

      // Announcement bar color change
      if (slideshow.classList.contains('announcement-bar--use-colors-true')) {
        args.on.change = function (index) {
          const container = slideshow.closest('.announcement-bar');
          let color_text = this.selectedElement.dataset.color,
            color_bg = this.selectedElement.dataset.bg;

          container.style.setProperty('--color-announcement-bar-bg', color_bg);
          container.style.setProperty('--color-announcement-bar-text', color_text);
        };
      }

      // Product Carousels
      if (slideshow.classList.contains('products')) {
        args.wrapAround = false;
        args.on.ready = function () {
          var flickity = this;
          if (next_button) {
            window.addEventListener('resize.center_arrows', function () {
              slideshow.centerArrows(flickity, slideshow, prev_button, next_button);
            });
          }
          window.dispatchEvent(new Event('resize.center_arrows'));
        };
      }
      if (progress_bar) {
        args.wrapAround = false;
        args.on.scroll = function (progress) {
          progress = Math.max(0, Math.min(1, progress));
          progress_bar.style.width = progress * 100 + '%';
        };
      }

      // Testimonials
      if (custom_dots) {
        args.on = {
          ready: function () {
            let flkty = this;

            // Custom Dots.
            let dots = custom_dots.querySelectorAll('li');
            dots.forEach((dot, i) => {
              dot.addEventListener('click', (e) => {
                flkty.select(i);
              });
            });
            dots[this.selectedIndex].classList.add('is-selected');
          },
          change: function (index) {

            // Custom Dots.
            let dots = custom_dots.querySelectorAll('li');
            dots.forEach((dot, i) => {
              dot.classList.remove('is-selected');
            });
            dots[this.selectedIndex].classList.add('is-selected');
          }
        };
      }

      // Customer reviews
      if (slideshow.classList.contains('customer-reviews--carousel')) {
        args.on.ready = function () {
          var flickity = this;
          if (next_button) {
            window.addEventListener('resize.center_arrows', function () {
              slideshow.centerArrows(flickity, slideshow, prev_button, next_button);
            });
          }
          window.dispatchEvent(new Event('resize.center_arrows'));
        };
      }

      // Initiate
      const flkty = new Flickity(slideshow, args);

      selectedIndex = flkty.selectedIndex;

      slideshow.dataset.initiated = true;


      // Arrows
      if (prev_button) {
        prev_button.addEventListener('click', (event) => {
          flkty.previous();
        });
        prev_button.addEventListener('keyup', (event) => {
          flkty.previous();
        });
        next_button.addEventListener('click', (event) => {
          flkty.next();
        });
        next_button.addEventListener('keyup', (event) => {
          flkty.next();
        });
      }

      // Theme editor
      if (Shopify.designMode) {
        slideshow.addEventListener('shopify:block:select', (event) => {
          let index = slideshow_slides.indexOf(event.target);
          flkty.select(index);
        });
      }

      // Setup split navigation
      this.setupSplitNavigation(flkty);

      // Resize-Event für Mobile-Höhen
      let resizeTimeout;
      window.addEventListener('resize', () => {
        clearTimeout(resizeTimeout);
        resizeTimeout = setTimeout(() => {
          if (window.innerWidth <= 767) {
            this.equalizeSlideHeights(slideshow);
          }
        }, 250);
      });

    }

    setupSplitNavigation(flkty) {
      const slideshow = this;
      // Suche nach der globalen Navigation (außerhalb der Slides)
      const globalNavigation = slideshow.querySelector('.slideshow__slide-split-navigation-global');

      if (!globalNavigation) return;

      const allDots = globalNavigation.querySelectorAll('.slideshow__slide-split-dot');
      const allArrows = globalNavigation.querySelectorAll('.slideshow__slide-split-arrow');

      if (allDots.length === 0 && allArrows.length === 0) return;

      console.log('Setting up global split navigation', { dots: allDots.length, arrows: allArrows.length });

      // Auf Mobile: Navigation in den aktuellen Bild-Container bewegen
      if (window.innerWidth <= 767) {
        try {
          this.moveNavigationToImageContainer(globalNavigation, flkty);
          setTimeout(() => this.equalizeSlideHeights(slideshow), 500);
        } catch (error) {
          console.error('Error in mobile setup:', error);
        }
      }

      // Update navigation on slide change
      flkty.on('change', (index) => {
        console.log('Slide changed to:', index);

        // Update slide opacity for better transitions
        const slides = slideshow.querySelectorAll('.carousel__slide');
        slides.forEach((slide, slideIndex) => {
          slide.classList.toggle('is-selected', slideIndex === index);
        });

        // Update all dots
        allDots.forEach((dot, dotIndex) => {
          dot.classList.toggle('is-selected', dotIndex === index);
        });

        // Update arrow states
        const prevArrows = globalNavigation.querySelectorAll('.slideshow__slide-split-arrow--prev');
        const nextArrows = globalNavigation.querySelectorAll('.slideshow__slide-split-arrow--next');

        prevArrows.forEach(arrow => {
          arrow.disabled = index === 0;
        });

        nextArrows.forEach(arrow => {
          arrow.disabled = index === flkty.slides.length - 1;
        });
      });

      // Add click handlers to dots
      allDots.forEach((dot, dotIndex) => {
        dot.addEventListener('click', (e) => {
          e.preventDefault();
          console.log('Dot clicked:', dotIndex);
          flkty.select(dotIndex);
        });
      });

      // Add click handlers to arrows
      allArrows.forEach(arrow => {
        arrow.addEventListener('click', (e) => {
          e.preventDefault();
          const direction = arrow.dataset.direction;
          console.log('Arrow clicked:', direction);

          if (direction === 'prev') {
            flkty.previous();
          } else if (direction === 'next') {
            flkty.next();
          }
        });
      });

      // Set initial state
      const currentIndex = flkty.selectedIndex;
      console.log('Initial slide index:', currentIndex);

      // Set initial slide states
      const slides = slideshow.querySelectorAll('.carousel__slide');
      slides.forEach((slide, slideIndex) => {
        slide.classList.toggle('is-selected', slideIndex === currentIndex);
      });

      allDots.forEach((dot, dotIndex) => {
        dot.classList.toggle('is-selected', dotIndex === currentIndex);
      });

      const prevArrows = globalNavigation.querySelectorAll('.slideshow__slide-split-arrow--prev');
      const nextArrows = globalNavigation.querySelectorAll('.slideshow__slide-split-arrow--next');

      prevArrows.forEach(arrow => {
        arrow.disabled = currentIndex === 0;
      });

      nextArrows.forEach(arrow => {
        arrow.disabled = currentIndex === flkty.slides.length - 1;
      });
    }

    moveNavigationToImageContainer(globalNavigation, flkty) {
      const slideshow = this;

      // Funktion um Navigation in aktuellen Bild-Container zu bewegen
      const moveToCurrentSlide = () => {
        const currentSlide = slideshow.querySelector('.carousel__slide.is-selected');
        if (currentSlide) {
          const imageWrapper = currentSlide.querySelector('.slideshow__slide-split-image-wrapper');
          if (imageWrapper) {
            // Navigation in den Bild-Container bewegen
            imageWrapper.appendChild(globalNavigation);
            console.log('Navigation moved to current image container');
          }
        }
      };

      // Initial bewegen
      moveToCurrentSlide();

      // Bei Slide-Wechsel Navigation bewegen
      flkty.on('change', () => {
        setTimeout(moveToCurrentSlide, 100); // Kurze Verzögerung für DOM-Update
      });
    }

    equalizeSlideHeights(slideshow) {
      try {
        // Nur auf Mobile ausführen
        if (window.innerWidth > 767) return;

        const splitContainers = slideshow.querySelectorAll('.slideshow__slide-split-container');
        if (splitContainers.length === 0) {
          console.log('No split containers found for height equalization');
          return;
        }

        console.log('Starting height equalization for', splitContainers.length, 'split containers');

        // Alle Container auf auto setzen für korrekte Messung
        splitContainers.forEach(container => {
          container.style.height = 'auto';
          container.style.minHeight = 'auto';
        });

        // Warten bis alle Inhalte geladen sind
        setTimeout(() => {
          let maxHeight = 0;

          // Höchste Container finden
          splitContainers.forEach((container, index) => {
            const height = container.offsetHeight;
            console.log(`Split container ${index} height:`, height);
            if (height > maxHeight) {
              maxHeight = height;
            }
          });

          console.log('Maximum split container height found:', maxHeight);

          // Alle Container auf die maximale Höhe setzen
          if (maxHeight > 0) {
            splitContainers.forEach((container, index) => {
              container.style.height = maxHeight + 'px';
              container.style.minHeight = maxHeight + 'px';
              console.log(`Set split container ${index} to height:`, maxHeight + 'px');
            });

            // Auch die Slides selbst setzen
            const slides = slideshow.querySelectorAll('.carousel__slide');
            slides.forEach((slide, index) => {
              slide.style.height = maxHeight + 'px';
              slide.style.minHeight = maxHeight + 'px';
            });

            console.log('✅ All split containers and slides equalized to:', maxHeight + 'px');
          } else {
            console.warn('No valid height found for equalization');
          }
        }, 150);
      } catch (error) {
        console.error('Error in equalizeSlideHeights:', error);
      }
    }

    setupAutoplayProgress(slideshow) {
      slideshow.autoPlayProgressTL = gsap.timeline({
        inherit: false
      });
      slideshow.autoPlayProgressTL
        .fromTo(slideshow.querySelector('.thb-slideshow-progress--svg circle'), {
          drawSVG: 0
        }, {
          duration: parseInt(slideshow.dataset.autoplay, 10) / 1000,
          ease: 'none',
          drawSVG: true
        });
      slideshow.addEventListener('mouseenter', function () {
        slideshow.autoPlayProgressTL.pause().progress(0);
      });
      slideshow.addEventListener('mouseleave', function () {
        slideshow.autoPlayProgressTL.play();
      });
    }

    videoPause(video_container) {
      setTimeout(() => {
        video_container.querySelector('video').pause();
      }, 10);
    }
    videoPlay(video_container) {
      setTimeout(() => {
        video_container.querySelector('video').play();
      }, 10);
    }
    prepareAnimations(slideshow, animations) {
      if (!slideshow.dataset.animationsReady) {
        // SplitText functionality removed to prevent unnatural line breaks

        slideshow.querySelectorAll('.slideshow__slide').forEach((item, i) => {
          let tl = gsap.timeline({
            paused: true
          }),
            button_offset = 0;


          animations[i] = tl;

          if (slideshow.dataset.transition == 'zoom') {
            tl
              .to(item.querySelectorAll('.slideshow__slide-bg, .slideshow__slide-video-bg'), {
                duration: 1.5,
                scale: 1
              }, "start");
          }

          if (item.querySelector('.inline-badge')) {
            tl
              .fromTo(item.querySelector('.inline-badge'), {
                opacity: 0
              }, {
                duration: 0.5,
                opacity: 1
              }, 0);

            button_offset += 0.2;
          }
          if (item.querySelector('.subheading')) {
            tl
              .fromTo(item.querySelector('.subheading'), {
                opacity: 0
              }, {
                duration: 0.5,
                opacity: 1
              }, 0);

            button_offset += 0.5;
          }
          if (item.querySelector('.slideshow__slide-heading')) {
            tl
              .fromTo(item.querySelectorAll('.slideshow__slide-heading'), {
                opacity: 0,
                y: 30
              }, {
                duration: 0.8,
                opacity: 1,
                y: 0,
                ease: "power2.out"
              }, 0);
            button_offset += 0.8;
          }
          if (item.querySelector('p.split-text')) {
            tl
              .fromTo(item.querySelectorAll('p.split-text'), {
                opacity: 0,
                y: 20
              }, {
                duration: 0.6,
                opacity: 1,
                y: 0,
                ease: "power2.out"
              }, 0.2);
            button_offset += 0.6;
          }
          if (item.querySelectorAll('.button, .text-button')) {
            tl
              .fromTo(item.querySelectorAll('.button, .text-button'), {
                y: '100%'
              }, {
                duration: 0.5,
                y: '0%',
                stagger: 0.1,
              }, button_offset * 0.2);
          }
          item.dataset.timeline = tl;
        });

        slideshow.dataset.animationsReady = true;
      }
    }
    animateSlides(i, slideshow, animations) {
      let flkty = Flickity.data(slideshow),
        active_slide = flkty.selectedElement;
      document.fonts.ready.then(function () {
        animations[i].restart();
      });
    }
    animateReverse(i, slideshow, animations) {
      animations[i].reverse();
    }
    centerArrows(flickity, slideshow, prev_button, next_button) {
      let first_cell = flickity.cells[0],
        max_height = 0,
        image_height = 0;
      if (first_cell.element.querySelector('.product-featured-image')) {
        image_height = first_cell.element.querySelector('.product-featured-image').clientHeight;
      } else if (first_cell.element.querySelector('.gallery--item')) {
        image_height = flickity.cells[1].element.querySelector('.product-featured-image').clientHeight;
      }
      if (slideshow.classList.contains('customer-reviews--carousel')) {
        if (first_cell.element.querySelector('.customer-reviews--product')) {
          image_height = flickity.cells[1].element.querySelector('.customer-reviews--product').clientHeight;
        }
      }
      if (image_height > 0) {
        flickity.cells.forEach((item, i) => {
          if (item.size.height > max_height) {
            max_height = item.size.height;
          }
        });

        if (max_height > image_height) {
          let difference = (max_height - image_height) / -2;

          prev_button.style.transform = 'translateY(' + difference + 'px)';
          next_button.style.transform = 'translateY(' + difference + 'px)';
        }
      }

    }
  }
  customElements.define('slide-show', SlideShow);
}
